<template>
  <div class="row">
    <div class="col-sm-12">
      <div class="card">
        <div class="card-header bg-primary">
          <h4 class="card-title text-white mb-0">Select insurance plan</h4>
        </div>
        <div class="card-body pt-3">
          <validation-observer v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(onSubmit)">
              <div class="row">
                <div class="col-sm-12">
                  <h5 class="text-muted text-center">Please select the duration and the plan which is suitable for your needs</h5>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 form-group">
                  <validation-input rules="required">
                    <div class="btn-group btn-group-toggle btn-block">
                      <label v-for="o in lovs.DURATION" :key="o.value" :class="['btn btn-light', data.CS_DATA.DURATION === o.value && 'active']">
                        <input v-model="data.CS_DATA.DURATION" :value="o.value" type="radio" />
                        {{ o.text }}
                      </label>
                    </div>
                  </validation-input>
                </div>
              </div>
              <div class="row justify-content-center mb-3">
                <div class="col-lg-12">
                  <div class="alert alert-primary mb-2" role="alert">
                    <div><i class="mdi mdi-lightbulb-on-outline text-success font-18"></i> Select annual plan and get 15% discount</div>
                  </div>
                </div>
              </div>
              <div class="row mb-3">
                <div
                  v-for="(item, index) in data.CT_MOTOR_INSURANCE_PLAN"
                  :key="index"
                  :class="['col-lg-4 mb-2 mb-lg-0 flex-column flip-card d-flex', index != data.CT_MOTOR_INSURANCE_PLAN.length - 1 ? 'mb-md-3' : '', item.SELECTED ? 'flipped' : '']"
                >
                  <div class="mb-0 flex-grow-1 flip-card-inner">
                    <div class="card-body flip-card-front d-flex">
                      <div class="row flex-grow-1">
                        <div class="col-sm-12 text-center">
                          <h3>{{ item.TITLE }}</h3>
                          <hr />
                        </div>
                        <div class="col-sm-12 flex-grow-1">
                          <div v-popper="{ placement: 'bottom-end' }">
                            <a href="javascript:;" class="" popper-trigger>
                              <span>
                                {{ item.CT_COVERS.length }} Covers
                                <!-- <i class="mdi mdi-chevron-down"></i> -->
                              </span>
                            </a>
                            <div class="dropdown-menu dropdown-menu-right p-3" popper>
                              <div class="row">
                                <div class="col">
                                  <ul class="list-unstyled mb-0 text-left">
                                    <li v-for="(cover, indexOfCover) in item.CT_COVERS" :key="indexOfCover">
                                      <i class="mdi mdi-check text-success font-18 line-height-1"></i>
                                      <span class="">{{ cover.TITLE }}</span>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-12 text-center align-self-end">
                          <button type="button" class="btn btn-lg btn-outline-primary btn-block" @click="selectCard(index)">Select</button>
                        </div>
                      </div>
                    </div>
                    <div class="card-body flip-card-back d-flex">
                      <div class="row flex-grow-1">
                        <i class="mdi mdi-close position-absolute cursor-pointer font-18" style="right: 5px; top: 5px; z-index:2;" @click="closeCard(index)"></i>
                        <div class="col-sm-12">
                          <h3>Select Start Date</h3>
                        </div>
                        <div class="col-sm-12 form-group mb-0">
                          <validation-input :name="`${item.TITLE} Start Date`" rules="required">
                            <div class="input-group">
                              <datepicker-input v-model="data.CS_DATA.START_DATE" @on-change="updateDate" />
                              <div class="input-group-btn">
                                <button type="submit" class="btn btn-outline-primary">
                                  OK
                                </button>
                              </div>
                            </div>
                          </validation-input>
                        </div>
                        <div class="col-sm-12">
                          <button type="button" class="btn btn-link" @click="next">Continue with open date</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 d-flex">
                  <div class="mr-auto">
                    <button type="button" class="btn btn-secondary" @click="previous">Previous</button>
                  </div>
                </div>
              </div>
            </form>
          </validation-observer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
// eslint-disable-next-line no-unused-vars
// import { format } from 'date-fns';

export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    lovs: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    ...mapActions('motor', ['updateValue']),
    onSubmit() {
      this.$emit('next');
    },
    next() {
      this.$emit('next');
    },
    previous() {
      this.$emit('previous');
    },
    selectCard(index) {
      for (let index = 0; index < this.data.CT_MOTOR_INSURANCE_PLAN.length; index++) {
        this.data.CT_MOTOR_INSURANCE_PLAN[index].SELECTED = false;
      }
      this.data.CT_MOTOR_INSURANCE_PLAN[index].SELECTED = true;
      this.updateValue({ path: 'motor.data.CT_MOTOR_INSURANCE_PLAN', value: this.data.CT_MOTOR_INSURANCE_PLAN });
    },
    closeCard(index) {
      this.updateValue({ path: `motor.data.CT_MOTOR_INSURANCE_PLAN[${index}.SELECTED`, value: false });
    },
    updateDate(event, date) {
      this.updateValue({ path: 'motor.data.CS_DATA.START_DATE', value: date });
    }
  }
};
</script>
